module.exports = __webpack_public_path__ + "img/racecourse-vaal-turf-1000.6453a591.svg";